export default {
  SET_scales(state, payload) {
    state.scales = payload
  },

  SET_scales_types(state, payload) {
    state.scales_types = payload
  },

  SET_employees_scales(state, payload) {
    state.employees_scales = payload
  },

  SET_swaps(state, payload) {
    state.swaps = payload
  },
}
